import React, { memo } from 'react';
import Headers from './Headers';
import List from './List';

const DataTable = props => <div className="position-relative">
    {
        (props.displayedOrders.length > 0) &&
        <Headers sortBy={header => props.sortBy(header)} {...props} />
    }
    <List refresh={() => props.refresh()} {...props} />
</div>
export default memo(DataTable);